
<sh-page >
  <div class="flex-row outline">
  <sh-card id="card-create-query" class="card" label='Create Query' icon='create-new-program' href='' (click)="createQuery()"></sh-card>
  <sh-card id="card-view-queries" class="card" label='View Queries' icon='document' href='' (click)="viewQueries()"></sh-card>
  <sh-card id="card-manage-templates" class="card" label='Manage Templates' icon='data-edit' href='' (click)="manageTemplates()"></sh-card>
  </div>

  <!-- Tooltips for the landing cards (targeted by id, kept outside the flex row so they don't affect layout) -->
  <sh-tooltip delay target="card-create-query" [label]="'landing.createQueryTooltip' | translate" placement="top" variation="long"></sh-tooltip>
  <sh-tooltip delay target="card-view-queries" [label]="'landing.viewQueriesTooltip' | translate" placement="top" variation="long"></sh-tooltip>
  <sh-tooltip delay target="card-manage-templates" [label]="'landing.manageTemplatesTooltip' | translate" placement="top" variation="long"></sh-tooltip>
</sh-page>

<sh-modal
  [visible]="showCreateQueryModal"
  label="Create Query"
  modal-height='fit-content'
  modal-width='350px'
  style="z-index: 105;"
  (modal-closed)="closeCreateQueryModal()">
  <div class="create-query-modal-body">
    <sh-radio-group>
      <sh-radio-button
        id="create-query-empty"
        label="Empty Query"
        [active]="selectedCreateQueryMode === 'empty'"
        (active-changed)="onCreateQueryModeChange('empty')">
      </sh-radio-button>
      <sh-radio-button
        id="create-query-fav"
        label="Favorite Query"
        [active]="selectedCreateQueryMode === 'fav_query'"
        (active-changed)="onCreateQueryModeChange('fav_query')">
      </sh-radio-button>
      <sh-radio-button
        id="create-query-default"
        label="Default Template"
        [active]="selectedCreateQueryMode === 'default'"
        (active-changed)="onCreateQueryModeChange('default')">
      </sh-radio-button>
      <sh-radio-button
        id="create-query-personal-templates"
        label="Personal Template"
        [active]="selectedCreateQueryMode === 'personal_template'"
        (active-changed)="onCreateQueryModeChange('personal_template')">
      </sh-radio-button>
      <sh-radio-button
        id="create-query-public-templates"
        label="Public Template"
        [active]="selectedCreateQueryMode === 'public_template'"
        (active-changed)="onCreateQueryModeChange('public_template')">
      </sh-radio-button>
    </sh-radio-group>

    <div class="template-picker" *ngIf="selectedCreateQueryMode === 'personal_template'">
      <sh-dropdown
        id="my-template-dropdown"
        [disabled]="isLoadingMyTemplates || myPersonalTemplates.length === 0"
        label="Select Template"
        [value]="selectedTemplate?.name">
        <sh-menu-item
          *ngFor="let template of myPersonalTemplates"
          [label]="template.name"
          [value]="template.name"
          (click)="onTemplateSelectionChange(template)"
          (key.enter)="onTemplateSelectionChange(template)">
        </sh-menu-item>
      </sh-dropdown>
      <sh-text size="body-2" class="template-state" *ngIf="!isLoadingMyTemplates && myPersonalTemplates.length === 0">
        No templates found.
      </sh-text>
    </div>
    
    <div class="template-picker" *ngIf="selectedCreateQueryMode === 'public_template'">
      <sh-dropdown
        id="my-public-template-dropdown"
        [disabled]="isLoadingMyTemplates || myPublicTemplates.length === 0"
        label="Select Template"
        [value]="selectedTemplate?.name">
        <sh-menu-item
          *ngFor="let template of myPublicTemplates"
          [label]="template.name"
          (click)="onTemplateSelectionChange(template)"
          (key.enter)="onTemplateSelectionChange(template)"
          >
        </sh-menu-item>
      </sh-dropdown>
      <sh-text size="body-2" class="template-state" *ngIf="!isLoadingMyTemplates && myPublicTemplates.length === 0">
        No templates found.
      </sh-text>
    </div>
    <div class="query-picker" *ngIf="selectedCreateQueryMode === 'fav_query'"> 
      <sh-dropdown
        id="my-favorite-query-dropdown"
        [disabled]="isLoadingMyTemplates || myFavoriteQueries.length === 0"
        label="Select Favorite Query"
        [value]="selectedTemplate?.name">
        <sh-menu-item
          *ngFor="let query of myFavoriteQueries"
          [label]="query.name"
          (click)="onQuerySelectionChange(query)"
          (key.enter)="onTemplateSelectionChange(query)"
          >
        </sh-menu-item>
      </sh-dropdown>
      <sh-text size="body-2" class="template-state" *ngIf="!isLoadingMyTemplates && myFavoriteQueries.length === 0">
        No favorite queries found.
      </sh-text>
    </div>

  </div>

  <sh-button
    id="create-query-confirm"
    slot='footer'
    label='Continue'
    [disabled]="!canConfirmCreateQuery()"
    (click)="confirmCreateQuery()"
    (keydown.enter)="confirmCreateQuery()">
  </sh-button>
</sh-modal>

<sh-page style='height: 50px'width='100%'>
  <div slot="footer" class="footer-container">
    <ul class="footer-links">
      <li class="footer-item" id="footerCopyRightInfo">©Siemens Healthineers AG - 2026 |</li>
      <li class="footer-item">
        <a href="https://www.healthcare.siemens.com/" rel="noopener noreferrer" target="_blank" class="footer-link">
          Siemens Healthineers Global Website |
        </a>
      </li>
      <li class="footer-item">
        <a href="../assets/privacy-policy.html" rel="noopener noreferrer" target="_blank" class="footer-link">Privacy Policy |</a>
      </li>
      <li class="footer-item">
        <a href="https://www.siemens-healthineers.com/cookie/" rel="noopener noreferrer" target="_blank" class="footer-link">
          Cookie Policy |
        </a>
      </li>
      <li class="footer-item">
        <a href="https://www.siemens-healthineers.com/corporate-info/" rel="noopener noreferrer" target="_blank" class="footer-link">
          Corporate Information |
        </a>
      </li>
      <li class="footer-item">
        <a href="../assets/term-of-use.html" rel="noopener noreferrer" target="_blank" class="footer-link">Terms of Use |</a>
      </li>
      <li class="footer-item">
        <a href="https://www.siemens-healthineers.com/corporate/digital-services-act" rel="noopener noreferrer" target="_blank" class="footer-link">
          Digital Services Act
        </a>
      </li>
    </ul>
  </div>
</sh-page>
    
 